export default __webpack_public_path__ + "static/media/mock-test.f055bbd6.svg";